export default "__VITE_ASSET__WmBSTaB7__"